import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { fetchDRTList_action } from "../../../actions/admin_module_action/daily_routine_task_action/daily_routine_task_action";
import { exhibitionId, serviceTypeId, toastError, contractorListActionId, toastSuccess, responsiblePersonListctionId, hallActionId, HallZoneActionId, HallZoneListActionId } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import DatePicker from "react-datepicker";
import moment from 'moment';
import zIndex from "@mui/material/styles/zIndex";
import AdminHeader from '../../../common_components/admin_module_header';


class DailyRoutineTaskList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            title: '',
            fromDate: '',
            toDate: '',
            Area: '',
            Rperson: '',
            AreaList: [],
            RpList: [],
            DRTList: [],
            tpending: '',
            tinprogress: '',
            tcompleted: '',
            DailyRoutineChecklistHdrID: '',
            mainList: [],
            showVideoModal: false,
            loginAccesslist: []
        }
        this.updateItem = this.updateItem.bind(this)
        this.renderList = this.renderList.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getDRTList = this.getDRTList.bind(this)
        this.onFilterClick = this.onFilterClick.bind(this)
    }
    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })

        this.getFillList(hallActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(responsiblePersonListctionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getDRTList()


    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === hallActionId) {
                            this.setState({ AreaList: data.data })
                            resolve()

                        }
                        if (actionID === responsiblePersonListctionId) {
                            this.setState({ RpList: data.data })
                            resolve()

                        }
                    }
                })
        })
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getViewAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.ReadAccess;
        } else {
            return false
        }
        return false;
    }


    getDRTList() {
        const { isLoading, title, DRTList, fromDate, toDate, Area, Rperson, AreaList, RpList } = this.state
        this.setState({ isLoading: true })
        this.props.fetchDRTList_action(title, fromDate, toDate, Area, Rperson)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data.length > 0) {
                    var temppemding = 0
                    var tempcomp = 0
                    var tempinPro = 0
                    // if (data.data[0].length > 0) {
                    var defaultList = []
                    data.data.map(item => {
                        if (item.Status == null || item.Status == 'Pending') {
                            defaultList.push(item)
                            temppemding = temppemding + 1
                        } else if (item.Status == 'InProgress') {
                            tempinPro = tempinPro + 1
                        } else if (item.Status == 'Completed') {
                            tempcomp = tempcomp + 1
                        }
                        if (item.Status == null) {
                            item.Status = 'Pending'
                        }
                    })
                    this.setState({ DRTList: defaultList, mainList: data.data, tcompleted: tempcomp, tinprogress: tempinPro, tpending: temppemding })
                    // }
                    // }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onFilterClick(mode) {
        const { isLoading, ExitNo, HallId, ZoneId, isOpen, mainList, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, tcomp, tpending } = this.state
        console.log("pppp")
        var templist
        if (mode == 0) {
            templist = mainList.filter(item => item.Status == 'Completed')
        } else if (mode == 1) {
            templist = mainList.filter(item => item.Status == 'InProgress')
        } else {
            templist = mainList.filter(item => item.Status == null || item.Status == 'Pending')
        }
        this.setState({ DRTList: templist })
    }


    renderList(currentRecords) {
        const { isLoading, title, DRTList, fromDate, toDate, Area, Rperson, AreaList, currentPage, RpList } = this.state
        return (
            <>
                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                    <thead class="table-light">
                        <tr>
                            <th class="text-center">Sr No.</th>
                            <th>Activity</th>
                            <th>Date</th>
                            <th>Schedule Time</th>
                            <th>Area</th>
                            {sessionStorage.getItem("RoleIDSS") != 16 && <th>Responsible Person</th>}
                            <th>Status</th>
                            {<th class="text-center" style={{ width: '70px' }}>Action</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {console.log(this.getUpdateAccess(), '{this.getUpdateAccess()')}
                        {currentRecords.length > 0 ? currentRecords.map((item, i) => (
                            <tr>
                                <td class="text-center">{((currentPage - 1) * 10) + (i + 1)}</td>
                                <td>{item.ProgramTitle}</td>
                                <td>{item.ChecklistDate != '' && item.ChecklistDate != null ? moment(item.ChecklistDate).format("DD/MM/YYYY") : ''}</td>
                                <td>{item.FromTime} {item.ToTime != '' && item.ToTime != null ? '-' : ''} {item.ToTime}</td>
                                <td>{item.HallName}</td>
                                {sessionStorage.getItem("RoleIDSS") != 16 && <td>{item.ResponsiblePerson}</td>}
                                <td>{item.Status}</td>
                                <td class="text-center act-col">
                                    {/* <a href="daily-routine-checklist-add.html"> */}
                                    {(this.getUpdateAccess() || sessionStorage.getItem('RoleIDSS') == 20) && <i class="bi bi-pencil grid-icon" title="Update task" onClick={() => this.handleUpdate(item.DailyRoutineChecklistHdrID, item.DailyRoutineChecklistHallID, item.DailyRoutineChecklistDateID, item.DailyRoutineChecklistScheduleTimeID, item.ProgramTitle, item.ChecklistDate != '' && item.ChecklistDate != null ? moment(item.ChecklistDate).format("DD/MM/YYYY") : '', `${item.FromTime} - ${item.ToTime}`, item.HallName, false)}></i>}
                                    {/* </a> */}
                                    {sessionStorage.getItem('RoleIDSS') != 16 && this.getUpdateAccess() && this.getViewAccess() && <span style={{ color: '#ccc' }}> | </span>}
                                    {(sessionStorage.getItem('RoleIDSS') != 16 && this.getViewAccess()) && <i class="bi bi-eye grid-icon" title="View task" onClick={() => this.handleUpdate(item.DailyRoutineChecklistHdrID, item.DailyRoutineChecklistHallID, item.DailyRoutineChecklistDateID, item.DailyRoutineChecklistScheduleTimeID, item.ProgramTitle, item.ChecklistDate != '' && item.ChecklistDate != null ? moment(item.ChecklistDate).format("DD/MM/YYYY") : '', `${item.FromTime} - ${item.ToTime}`, item.HallName, true)} ></i>}
                                </td>
                            </tr>)) : <tr>
                            <td colSpan={12} className="text-center">Record not found</td>
                        </tr>}
                    </tbody>
                </table>
            </>
        )
    }

    // Update Current Page
    updateItem(item) {
        const { accountEntryPassList } = this.state
        this.setState({ currentPage: item });
    }

    clearValue() {
        this.setState({
            title: '',
            // DRTList:''
            fromDate: '',
            toDate: '',
            Area: '',
            Rperson: '',
            // AreaList
            // RpList
        })
        setTimeout(() => {
            this.getDRTList()
        }, 100);
    }

    handleUpdate(id1, id2, id3, id4, name, datestr, timestr, hallstr, status) {
        // if (id != null) {
        this.props.navigate('/dailyRoutineTaskUpdate', { state: { DailyRoutineChecklistHdrID: id1, DailyRoutineChecklistHallID: id2, name: name, datestr: datestr, timestr: timestr, hallstr: hallstr, DailyRoutineChecklistDateID: id3, DailyRoutineChecklistScheduleTimeID: id4, isView: status } })
        // } else {
        //     this.props.navigate('/dailyRoutineTaskUpdate')
        // }
    }

    render() {
        const { isLoading, isOpen, title, currentPage, DRTList, fromDate, toDate, Area, Rperson, AreaList, RpList } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = DRTList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(DRTList.length / recordsPerPage)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                {this.state.showVideoModal && (
                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
                        <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Daily Routine Task</h5>
                                    <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                                </div>
                                <div className="modal-body">
                                    <video controls autoPlay style={{ width: '100%' }}>
                                        <source src="/assets/DailyRoutineTask.mp4" type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {sessionStorage.getItem("RoleIDSS") != 16 || sessionStorage.getItem("RoleIDSS") != 20 ? <HeaderWithLogo /> : <HeaderWithLogo />
                }
                {/* <HeaderWithLogo /> */}
                <>
                    {sessionStorage.getItem("RoleIDSS") != 16 && sessionStorage.getItem("RoleIDSS") != 20 && <AdminDrawer />}
                    {/* <div className="app-content with-dr-container page-scroll"> */}

                    <div className={sessionStorage.getItem("RoleIDSS") != 16 && sessionStorage.getItem("RoleIDSS") != 20 ? "app-content with-dr-container page-scroll" : "main-content page-scroll"}>
                        {sessionStorage.getItem("RoleIDSS") === "6" && (
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">
                                        Daily Routine Task
                                    </h6>
                                </div>
                            </div>
                        )}
                        <main id="main">
                            <div
                                className={`pagetitle d-flex justify-content-between border-bottom ${sessionStorage.getItem("RoleIDSS") == 16 || sessionStorage.getItem("RoleIDSS") == 20 ? "admin-top-space" : "vendor-top-space"
                                    }`}
                            >
                                {/* <nav>
                                    <ol class="breadcrumb mb-0" style={{ background: 'none' }}>
                                        <li class="breadcrumb-item active fw-bolder pt-2" style={{ background: 'none' }}>
                                            {sessionStorage.getItem("RoleIDSS") == 16 ? 'Hall Manager' : 'Organizer'}  Daily Routine Task
                                        </li>
                                    </ol>
                                </nav> */}
                                {/* <a href="daily-routine-checklist-add.html"> */}
                                {/* <button class="btn btn-aqua p-1 px-2" onClick={() => this.handleUpdate(null)}>
                                    Add Daily Routine Checklist
                                </button> */}
                                {/* </a> */}
                            </div>
                            <section class="section p-0">
                                <div className="d-flex justify-content-end mb-2 mx-3">
                                    <span
                                        onClick={() => this.setState({ showVideoModal: true })}
                                        style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px' }}
                                    >
                                        <i className="bi bi-play-circle-fill me-2"></i>User Manual
                                    </span>
                                </div>
                                <div class="row m-0 mb-1 me-2">
                                    <div class="col-md-2">
                                        <label class="">Activity</label>
                                        <input type="text" class="form-control" value={title} onChange={(e) => this.setState({ title: e.target.value })} />
                                    </div>

                                    <div class="col-md-2">
                                        <label class="">From Date</label>
                                        <DatePicker className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            selected={fromDate != '' && fromDate != null ? new Date(fromDate) : ''}
                                            // onChange={(e) => this.onExpiryAUChange(e)}
                                            onChange={(e) => this.setState({
                                                fromDate: e
                                            })}
                                            // maxDate={new Date(ToDate)}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="dd-mm-yyyy"
                                        />                                                        </div>

                                    <div class="col-md-2">
                                        <label class="">To Date</label>
                                        <DatePicker className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            selected={toDate != '' && toDate != null ? new Date(toDate) : ''}
                                            // onChange={(e) => this.onExpiryAUChange(e)}
                                            onChange={(e) => this.setState({
                                                toDate: e
                                            })}
                                            // maxDate={new Date(ToDate)}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="dd-mm-yyyy"
                                        />                                                        </div>

                                    <div class="col-md-2">
                                        <label class="">Area</label>
                                        <select
                                            className="form-control form-control-sm w-100"
                                            id="roledb"
                                            style={{ textAlign: "left" }}
                                            value={Area}
                                            // disabled={isView || isReadOnly}
                                            onChange={(e) => this.setState({ Area: e.target.value })}
                                        >
                                            <option value="">Select</option>
                                            {AreaList.length > 0 && AreaList.map((data) => (
                                                <option key={data.HallId} value={data.HallId}>{data.HallName}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {sessionStorage.getItem("RoleIDSS") != 16 ? <div class="col-md-2">
                                        <label class="">Responsible Person</label>
                                        <select
                                            className="form-control form-control-sm w-100"
                                            id="roledb"
                                            style={{ textAlign: "left" }}
                                            value={Rperson}
                                            // disabled={isView || isReadOnly}
                                            onChange={(e) => this.setState({ Rperson: e.target.value })}
                                        >
                                            <option value="">Select</option>
                                            {RpList.length > 0 && RpList.map((data) => (
                                                <option key={data.AccountID} value={data.AccountID}>{data.Name}</option>
                                            ))}
                                        </select>
                                    </div> : <></>}
                                    <div className="col-md-3 text-left">
                                        <label></label>
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-aqua mx-1 list-btn"
                                                onClick={() => this.getDRTList()}
                                            >
                                                Search
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-gray list-btn"
                                                onClick={() => this.clearValue()}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                    {/* <div > */}
                                    {/* </div> */}
                                </div>
                                <div class="d-flex justify-content-end align-items-center m-0 mx-3 mb-1">
                                    <div class="d-flex align-items-center gap-1">
                                        <div class="p-1 rounded-1 status-btn" onClick={() => this.onFilterClick(2)} style={{ cursor: 'pointer' }}>
                                            <i class="fa fa-file-text fs-6"></i>  &nbsp;
                                            <span >Pending:</span>
                                            <strong class="ms-1 ">{this.state.tpending}</strong>
                                        </div>

                                        <div class="p-1 rounded-1 status-btn" onClick={() => this.onFilterClick(1)} style={{ cursor: 'pointer' }}>
                                            <i class="fa fa-hourglass-half fs-6"></i>  &nbsp;
                                            <span>In Progress:</span>
                                            <strong class="ms-1">{this.state.tinprogress}</strong>
                                        </div>

                                        <div class="p-1 rounded-1 status-btn" onClick={() => this.onFilterClick(0)} style={{ cursor: 'pointer' }}>
                                            <i class="bi bi-check-circle-fill fs-6"></i> &nbsp;
                                            <span class="">Completed:</span>
                                            <strong class="ms-1">{this.state.tcompleted}</strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-0">

                                    <div class="table-responsive">
                                        {this.renderList(currentRecords)}
                                    </div>
                                </div>
                                <div class="m-2 float-right trp">

                                    {
                                        DRTList.length > 0 ?
                                            <Pagination
                                                nPages={nPages}
                                                currentPage={currentPage}
                                                setCurrentPage={this.updateItem}
                                            /> : <></>
                                    }
                                    <div class="table-record-pages">
                                        Page <strong>{currentPage}</strong> of <strong>{nPages}</strong>
                                    </div>
                                </div>
                            </section>
                        </main>
                    </div>

                    <Modal isOpen={this.state.isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header bg-danger text-white py-2">
                                    <p class="modal-title" style={{ fontSize: "16px" }}>     Confirm Delete</p>
                                    <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen: false, })} ></button>
                                </div>
                                <div class="modal-body">
                                    {/* <div class="mb-0">
                                                                    <label class="col-form-label">Reason</label>
                                                                    <textarea id="refuseReason" class="form-control" rows="4" placeholder="Enter reason here..." onChange={(e) => this.setState({ refuseReason: e.target.value })} value={this.state.refuseReason}></textarea>
                                                                </div> */}
                                    <p class="pop_label">Do you really want to delete this Record?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-gray" onClick={(e) => this.deleteDRC(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray" onClick={() => this.setState({ isOpen: false, })}>No</button>

                                    {/* <button type="button" class="btn btn-danger" onClick={() => this.onGenerateExitPass(0)}>Refuse</button> */}
                                </div>
                            </div>
                        </div>
                    </Modal>
                </>
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action,
    fetchDRTList_action,
    //  delateDRC_action
})(DailyRoutineTaskList));